/**
 * @fileoverview GET handler for the "/internal_user_groups/:internal_user_group_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appSettingsInternalUserGroupsInternalUserGroupId } from "./constants";
import type { AppSettingsInternalUserGroupsInternalUserGroupIdResult } from "./types";

export const getAppSettingsInternalUserGroupsInternalUserGroupId = reactQueryFetcherAdapter(
  appSettingsInternalUserGroupsInternalUserGroupId,
  (
    signal: AbortSignal,
    internalUserGroupId: string
  ): Promise<AppSettingsInternalUserGroupsInternalUserGroupIdResult> => {
    return fetch(
      `/internal_user_groups/${internalUserGroupId}`,
      "GET",
      {},
      { signal },
      {
        propagateFetchRequestError: false,
      }
    );
  }
);
